/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendD8GridResponseDto } from '../../models/backend-d-8-grid-response-dto';

export interface GetGridDashboardsD8GridGet$Params {
  /**
   * ID проекта (обязательно)
   */
  project_id: number;

  /**
   * ID сценария; дефолт — активный
   */
  scenario_id?: number | null;

  /**
   * Начало периода YYYY-MM-DD
   */
  from?: string | null;

  /**
   * Конец периода YYYY-MM-DD
   */
  to?: string | null;

  /**
   * month — помесячно, year — годовая агрегация
   */
  granularity?: 'month' | 'year';
}

export function getGridDashboardsD8GridGet(
  http: HttpClient,
  rootUrl: string,
  params: GetGridDashboardsD8GridGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendD8GridResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getGridDashboardsD8GridGet.PATH, 'get');
  if (params) {
    rb.query('project_id', params.project_id, {});
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('granularity', params.granularity, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendD8GridResponseDto>;
    }),
  );
}

getGridDashboardsD8GridGet.PATH = '/dashboards/d8/grid';
